import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

const defaultState = {
  title: 'Events Management',
  showBack: false,
  showConfirmBack: false,
  onBack: undefined,
  headerClassName: undefined
};

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [headerState, setHeaderState] = useState(defaultState);

  const setHeader = useCallback((newState) => {
    setHeaderState((prev) => ({ ...prev, ...newState }));
  }, []);

  const resetHeader = useCallback(() => setHeaderState(defaultState), []);

  const value = useMemo(
    () => ({ headerState, setHeader, resetHeader }),
    [headerState, setHeader, resetHeader]
  );

  return (
    <HeaderContext.Provider value={value}>
      {children}
    </HeaderContext.Provider>
  );
};

HeaderProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) throw new Error('useHeader must be used within HeaderProvider');
  return context;
};
